import React, { Component } from 'react';
import type { WorkSessionsState } from '../../../types';

type Props = {
  month: number,
  day: number,
  dayName: string,
  date: string,
  isToday: boolean,
  onTabLinkClick: (dayName: string) => void,
  activeTab: string,
  workSessions: WorkSessionsState,
  deskLabel?: string,
}

class DayHeadingSmall extends Component<Props> {
  handleClick = (event: any) => {
    event.preventDefault();
    const { dayName, onTabLinkClick } = this.props;
    onTabLinkClick(dayName);
  };

  getCheckinTime = (checkinTime: string) => {
    const date = new Date(checkinTime);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  };

  render() {
    const {
      month, day, dayName, date, isToday, activeTab, workSessions, deskLabel,
    } = this.props;
    let liClasses = 'nav-item col seven-cols';
    let linkClasses = 'nav-link js-day-navigation';
    if (isToday) {
      liClasses += ' today';
      linkClasses += ' highlight-today';
    }
    if (activeTab === dayName) {
      linkClasses += ' active';
    }

    const workSession = Object.values(workSessions.byId).find(
      session => session.date === date
    );

    return (
      <li className={liClasses} data-date={day}>
        <a className={linkClasses} href={`#${dayName}`} data-day={`${month}-${day}`} onClick={this.handleClick}>
          <div>{`${day}/${month}`}</div>
          {workSession && workSession.checkinTime && (
            <div style={{ fontSize: '0.75em', color: '#ABB0CB' }}>
              Checked in: {this.getCheckinTime(workSession.checkinTime)}
            </div>
          )}
          {deskLabel && (
            <div style={{ fontSize: '0.75em', color: '#ABB0CB' }} title={`Desk ${deskLabel}`}>
              <i className="fa fa-desktop" aria-hidden="true" /> {deskLabel}
            </div>
          )}
        </a>
      </li>
    );
  }
}

export default DayHeadingSmall;
